export function guestHeader() {
    // return authorization header with jwt token
    const safeParse = (value, fallback = null) => {
        if (value === undefined || value === null || value === '' || value === 'undefined' || value === 'null') {
            return fallback;
        }
        try {
            return JSON.parse(value);
        } catch (error) {
            return fallback;
        }
    };

    let interface_language_id = safeParse(localStorage.getItem('interface_language_id'));
    if (interface_language_id && interface_language_id !== '') {
        return {'Content-Type': 'application/json', 'Interface-Language-Id': interface_language_id};
    } else {
        return {'Content-Type': 'application/json'};
    }
}